/* eslint-disable react/jsx-no-target-blank */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { LogoWhite } from '../logo/logo-white';
import { routes } from '../../routing/routes';
import { useCopyToClipboard } from '../../hooks/use-copy-to-clipboard';
import { useParentFolder } from '../_folder/new-button/use-parent-folder';


export function Header(props: { title?: string; download?: string; preview?: string; }) {

    const openedFolder = useParentFolder();
    const backTo = useMemo(() => {
        if (openedFolder) {
            return openedFolder.alias;
        } return undefined;
    }, [openedFolder]);

    const router = useHistory();

    const goBack = useCallback(() => {
        router.push(routes.folder + `/${backTo || ''}`);
    }, [router, backTo]);

    const { copied, copy, clipboardIsSupported } = useCopyToClipboard(props.preview || '');

    return (
        <div className="w-100 position-relative preview-header" style={{ zIndex: 1 }}>
            <div title="View the LCMS Document Library" className="preview-cta w-100 px-5 py-3 bg-white text-dark d-flex justify-content-between align-items-center" onClick={goBack} style={{ fontFamily: 'Montserrat', fontWeight: 'bold', fontSize: '13px', cursor: 'pointer' }}>
                <div className="d-flex justify-items-center align-items-center" ><FontAwesomeIcon icon={['fas', 'arrow-to-left']} className="me-2" style={{ fontSize: '18px' }} /> <span className='link' style={{ fontFamily: 'Roboto' }}>Return to Document Library</span></div>
            </div>
            <div className="w-100 px-5 py-3  bg-dark text-white">
                <div className="d-flex justify-content-between align-items-center">
                    <div className='me-5'>
                        <div className="pt-1 mb-3 preview-logo" style={{ cursor: 'pointer' }} onClick={goBack} title="View the LCMS Document Library"><LogoWhite style={{ width: '192.5px' }} /></div>
                        {!clipboardIsSupported && <div className="ms-5 mt-3 pe-3 ip-link w-75">{props.download}</div>}
                        <small className="fw-bold mt-3 preview-title">{props.title}</small>
                    </div>

                    {props.download && <div className="mt-2">
                        <a href={props.download} target="_blank" className="btn btn-soft w-100" style={{ 'minWidth': '138px' }}><FontAwesomeIcon icon={['fas', 'file-download']} className="me-2" /><b>Download</b></a> <br />
                        {clipboardIsSupported && <div className="mt-3" style={{ 'color': "#fff", 'cursor': 'pointer' }} onClick={copy}>{copied ? <FontAwesomeIcon icon={['fal', 'check']} className="me-2" style={{ 'fontSize': '13.5px' }} /> : <FontAwesomeIcon icon={['fal', 'link']} className="me-2" />}<span style={{ 'fontSize': '12px' }}>{copied ? 'Copied!' : 'Copy shareable link'}</span></div>}
                    </div>}
                </div>
            </div>
        </div>

    );
}
